import axios, { AxiosResponse } from 'axios'

import { FloorPlanId, FloorPlanRead, FloorPlanWrite } from '@generated/types'

const BASE_URL = '/api/floor-plan'

export default {
  async fetchAll(): Promise<AxiosResponse<FloorPlanRead[]>> {
    return axios.get<FloorPlanRead[]>(`${BASE_URL}/`)
  },

  // Note: Original addFloorPlan didn't specify return type
  async create(data: FloorPlanWrite): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/`, data)
  },

  async createDetailed(data: FloorPlanWrite): Promise<AxiosResponse<FloorPlanRead>> {
    return axios.post(`${BASE_URL}/`, data)
  },

  async delete(id: FloorPlanId): Promise<AxiosResponse> {
    return axios.delete(`${BASE_URL}/${id}/`)
  },

  async updateDetailed(data: FloorPlanWrite): Promise<AxiosResponse<FloorPlanRead>> {
    // Ensure data.id exists before using it in the URL
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Floor plan ID is required for update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/`, data)
  },

  async duplicate(id: FloorPlanId): Promise<AxiosResponse<FloorPlanRead>> {
    // Changed id type from number
    return axios.post(`${BASE_URL}/${id}/duplicate/`)
  },
}
